import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  templateUrl: './paginaError.component.html'
})
export class PaginaErrorComponent {
  constructor(private router: Router) {}

  goHome() {
    this.router.navigateByUrl('/'); // o a /encuestas
  }
}